import { LogEnum } from '../LogEnum';

export interface BnumConfigLocalKeys {
	today?: string;
	tomorrow?: string;
	day?: string;
	invalid_date?: string;
	last_mails?: string;
	no_mails?: string;
	last_events?: string;
	no_events?: string;
	valid_input?: string;
	invalid_input?: string;
	error_field?: string;
	search_field?: string;
	active_switch?: string;
	inactive_switch?: string;
}

export interface BnumConfigOptions {
	local_keys?: BnumConfigLocalKeys;
	console_logging?: boolean;
	console_logging_level?: LogEnum;
	tag_prefix?: string;
}

export const DEFAULT_CONFIG: BnumConfigOptions = {
	local_keys: {
		today: "Aujourd'hui",
		tomorrow: 'Demain',
		day: 'Journée',
		invalid_date: 'Date invalide',
		last_mails: 'Courriers récents',
		no_mails: 'Aucun courrier...',
		last_events: 'Prochains évènements',
		no_events: 'Aucun événement...',
		valid_input: 'Le champs est valide !',
		invalid_input: 'Le champs est invalide !',
		error_field: 'Ce champ contient une erreur.',
		search_field: 'Rechercher',
		active_switch: 'Activé',
		inactive_switch: 'Désactivé',
	},
	console_logging: true,
	console_logging_level: LogEnum.TRACE,
	tag_prefix: 'bnum',
};
